import React, {useState} from "react"

import styles from "./SendModal.module.css"
import closeBtn from "../../assets/mobileClose.svg"
import {sendRequest} from "../../common";

function SendModal({ setSendOpen, title1, text1, title2, text2, info, applyTest, reload}) {

	const closeSend = () => {
		setSendOpen(false)
	}

	const [sentCount, setSentCount] = useState(applyTest?.sentCount)

	let isLoading = false
	const sendCodes = () => {
		if (sentCount >= 3) {
			alert('3회 까지만 발송 가능합니다.')
			return
		}
		if (isLoading) return
		isLoading = true

		setTimeout(() => alert('발송 되었습니다.'), 1000)
		sendRequest('test/send-apply-test/', 'POST', {
			applyTestIds: [applyTest?.id],
		}, data => {
			// setSentCount((parseInt(sentCount) + 1)?.toString())
			reload()
			setSendOpen(false)
			isLoading = false
		}, (data, code) => {
			isLoading = false
		})
	}

	return (
		<>
			<div className={styles.modalWrap}>
				<div className={styles.sendModal}>
					<div className={styles.modalHeader}>
						<h2>발송현황</h2>
						<button type="button" onClick={closeSend}>
							<img src={closeBtn} alt="팝업 닫기" />
						</button>
					</div>
					<div className={styles.modalText}>
						<p><span>{sentCount}{title1}</span> {text1}</p>
						<p><span>{title2}</span> {text2}</p>
						<span className={styles.info}>{info}</span>
					</div>
					<div className={styles.modalBtn}>
						{!applyTest?.isDone &&
							<button type="submit" onClick={sendCodes} style={{marginBottom: 10}}>
								재전송
							</button>
						}
						<button onClick={() => setSendOpen(false)} style={{backgroundColor: '#fff', color: '#333', border: 'solid 1px #333'}}>
							확인
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default SendModal
